import { FC } from 'react';

type Props = {
	className?: string;
};

const IdeaIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M5.27228 12.3992C4.96956 11.7188 4.80078 10.9617 4.80078 10.164C4.80078 7.20116 7.12888 4.79932 10.0007 4.79932C12.8726 4.79932 15.2007 7.20116 15.2007 10.164C15.2007 10.9617 15.0319 11.7188 14.7292 12.3992'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M10 1.99951V2.7995'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M17.9992 9.99951H17.1992'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M2.79999 9.99951H2'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M15.6555 4.34229L15.0898 4.90797'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M4.90943 4.90894L4.34375 4.34326'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M12.0139 15.8445C12.8223 15.5831 13.1464 14.8433 13.2376 14.0991C13.2648 13.8768 13.0819 13.6924 12.8579 13.6924L7.18187 13.6925C6.95019 13.6925 6.76413 13.8892 6.7918 14.1192C6.88111 14.8619 7.10655 15.4044 7.96314 15.8445M12.0139 15.8445C12.0139 15.8445 8.10415 15.8445 7.96314 15.8445M12.0139 15.8445C11.9167 17.4005 11.4674 18.0167 10.0058 17.9995C8.44246 18.0283 8.08281 17.2667 7.96314 15.8445'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default IdeaIcon;
